import React, { useCallback, useContext, useEffect, useState } from 'react';
import { IGraphMessage } from '../../graphql/schema/p4types';
import { useDispatch } from 'react-redux';
import { appActions } from '../../state/modules/app';
import GraphMessageWorkspace from './GraphMessageWorkspace';
import AppContext from '../../components/Context/AppContext';
import { Dropdown, IDropdownOption } from '@fluentui/react';

export default function OutlookTab({ emailAddresses }: { emailAddresses: string[] }) {
  const { fullUserDetails } = useContext(AppContext);
  const dispatch = useDispatch();
  const [mailbox, setMailbox] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (fullUserDetails?.systemUser?.msftMailboxes?.[0]) {
      setMailbox(fullUserDetails.systemUser.msftMailboxes[0]);
    }
  }, [fullUserDetails?.systemUser?.msftMailboxes]);

  const onRowClick = useCallback(
    (row: IGraphMessage) => {
      dispatch(appActions.toggleMailSidebar(false, row.id, mailbox));
    },
    [mailbox]
  );

  const getOptions = useCallback((): IDropdownOption[] => {
    return (
      fullUserDetails?.systemUser?.msftMailboxes?.map((mailbox) => {
        return {
          key: mailbox!,
          text: mailbox!,
        };
      }) || []
    );
  }, [fullUserDetails?.systemUser?.msftMailboxes]);

  if (!emailAddresses || emailAddresses.length === 0) {
    return null;
  }

  return (
    <>
      {fullUserDetails?.systemUser?.msftMailboxes?.length || 0 > 1 ? (
        <Dropdown
          label="Mailbox"
          options={getOptions()}
          selectedKey={mailbox}
          onChange={(_event, item) => setMailbox(item?.key as string)}
        />
      ) : null}
      <GraphMessageWorkspace onRowClick={onRowClick} emailAddresses={emailAddresses} mailbox={mailbox} embeddedView />
    </>
  );
}
